import * as React from "react";
import IdleTimer from "react-idle-timer";
import App from "./App";
import { AuthHelper } from "./helpers/AuthHelper";
import * as dateFns from "date-fns";
import { store } from "src";
import { getRefreshUserTokenAction } from "./Entities/User/User.Actions";
import { PagesContainer } from './context/pages';
interface IState {
  userLastDataRefresh: Date;
}

class AppSession extends React.Component<{}, IState> {
  /**
   *
   */
  private idleTimer: any;
  private timeBeforeRefresh: number;
  private timeOutMin: number;
  constructor(props: any) {
    super(props);
    this.idleTimer = null;
    this.timeBeforeRefresh = 10;
    this.timeOutMin = 30;
    this.state = { userLastDataRefresh: new Date() };
    this._onAction = this._onAction.bind(this);
    this._onActive = this._onActive.bind(this);
    this._onIdle = this._onIdle.bind(this);
  }

  public render() {
    return (
      <>
        <IdleTimer
          ref={ref => {
            this.idleTimer = ref;
          }}
          element={document}
          onAction={this._onAction}
          onIdle={this._onIdle}
          onActive={this._onActive}
          debounce={250}
          timeout={1000 * 60 * this.timeOutMin}
        />
        <PagesContainer>
          <App />
        </PagesContainer>
      </>
    );
  }

  public _onAction() {
    const timeDiff = dateFns.differenceInMinutes(
      new Date(),
      this.state.userLastDataRefresh
    );

    if (timeDiff >= this.timeBeforeRefresh) {
      // we refresh the user date
      store.dispatch(getRefreshUserTokenAction());
      this.setState(
        Object.assign(this.state, {
          userLastDataRefresh: new Date(this.idleTimer.getLastActiveTime())
        })
      );
    }
  }

  public _onActive() {
    // this is void since we redirect before calling _onActive()
  }

  public _onIdle() {
    // we logOff the user if they idle for more than this.state.timeOutMin
    AuthHelper.LogOff();
  }
}

export default AppSession;



// WEBPACK FOOTER //
// ./src/AppSession.tsx